import { render, staticRenderFns } from "./CommissionOrders.vue?vue&type=template&id=5d51146d&scoped=true&"
import script from "./CommissionOrders.vue?vue&type=script&lang=js&"
export * from "./CommissionOrders.vue?vue&type=script&lang=js&"
import style0 from "./CommissionOrders.vue?vue&type=style&index=0&id=5d51146d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d51146d",
  null
  
)

export default component.exports